import { stringify } from "query-string"
import { farasodAuth } from "./api"

const endpoint = "/account"

export const getOtp = async (data, type = "mobilePhone") => {
  const response = await farasodAuth.post(`${endpoint}/otp/${type}`, data)

  return response.data
}

export const getOtpForMobile = async data => {
  const response = await farasodAuth.post(`${endpoint}/otp/mobilePhone`, data)

  return response.data
}

export const confirmOtp = async (data, type = "mobilePhone") => {
  const response = await farasodAuth.post(`${endpoint}/otp/confirm/${type}`, data)

  return response.data
}

export const signin = async (data, type = "mobilePhone") => {
  const response = await farasodAuth.post(`${endpoint}/login/${type}`, data)

  return response.data
}

export const getUserAccountInfo = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasodAuth.get(`${endpoint}/info?${query}`)

  return response.data
}

export const editUserAccountInfo = async () => {
  const response = await farasodAuth.patch(`${endpoint}/info`)

  return response.data
}

export const getAllUserAccounts = async mobile => {
  const response = await farasodAuth.get(`${endpoint}/manage/info/${mobile}`)

  return response.data
}

export const changeUserRole = async (mobile, role) => {
  const response = await farasodAuth.patch(`${endpoint}/manage/changeRole/${mobile}/${role}`)

  return response.data
}

export const getUserList = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasodAuth.get(`${endpoint}/userList?${query}`)

  return response.data
}

export const addUser = async (data) => {
  const response = await farasodAuth.post(`${endpoint}/user/access`, data)

  return response.data
}

export const editUser = async (data, accountId) => {
  const response = await farasodAuth.patch(`${endpoint}/user/access/${accountId}`, data)

  return response.data
}

export const userLogoutRefreshToken = async () => {
  const response = await farasodAuth.post(
    `${endpoint}/logout`,
    { refreshToken: localStorage.getItem("rt") }
  )

  return response.data
}

export const refreshAccessToken = async () => {
  const refreshToken =
    localStorage.getItem("rt")

  if (!refreshToken) return

  const response =
    await farasodAuth.post(
      `${endpoint}/refresh/token`,
      { refreshToken }
    )

  return response.data
}